import React, { useEffect, useState } from "react";
import "./dashboard.scss";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { BsDownload } from "react-icons/bs";
import { IoIosListBox } from "react-icons/io";
import { MdNotificationAdd } from "react-icons/md";
import { MdMessage } from "react-icons/md";
import pic4 from "../../img/pic4.jpeg";
import { BsChevronDown } from "react-icons/bs";
import { IoMdListBox } from "react-icons/io";
import { BiTimeFive } from "react-icons/bi";
import { BsFillBagPlusFill } from "react-icons/bs";
import { GrCompliance } from "react-icons/gr";
import { RiBankCardFill } from "react-icons/ri";
import { FaCircleNotch } from "react-icons/fa";
import { RiInboxArchiveLine } from "react-icons/ri";
import pic1 from "../../img/pic1.png";
import { getTaskById } from "../../services/tasks/tasks";
import { useParams } from "react-router-dom";
import styles from "./dashboard.module.scss";
import addNotification from "react-push-notification";
import { Link } from "react-router-dom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  registerables,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
ChartJS.register(
  ...registerables,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);
export const labels = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

export default function Dashboard(props) {
  const [dashBoard, setDashBoard] = useState([]);
  const [totalStoryPoints, setTotalStoryPoints] = useState("");
  const [membersLength, setMembersLength] = useState("");
  const [chartData, setChartData] = useState({
    labels,
    datasets: [
      {
        fill: true,
        label: "Todo",
        data: dashBoard?.Boards?.map((item) => {
          if (
            item.title === "TODO" ||
            item.title === "todo" ||
            item.title === "ToDO" ||
            item.title === "ToDO" ||
            item.title === "TOdo" ||
            item.title === "TOdo" ||
            item.title === "tODO" ||
            item.title === "tODO" ||
            item.title === "toDO"
          ) {
            return item.cards.length;
          }
        }),

        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
      {
        fill: true,
        label: "Progress",
        data: dashBoard?.Boards?.map((item) => {
          if (item.title === "PROGRESS" || item.title === "progress") {
            return item.cards.length;
          }
        }),
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        fill: true,
        label: "Done",
        data: dashBoard?.Boards?.map((item) => {
          if (
            item.title === "DONE" ||
            item.title === "done" ||
            item.title === "Done" ||
            item.title === "DoNE" ||
            item.title === "DONe" ||
            item.title === "dONE" ||
            item.title === "dOne" ||
            item.title === "doNE" ||
            item.title === "donE"
          ) {
            return item.cards.length;
          }
        }),

        borderColor: "rgb(75, 192, 192)",
        backgroundColor: "rgba(75, 192, 192, 0.5)",
      },
      {
        fill: true,
        label: "QA",
        data: dashBoard?.Boards?.map((item) => {
          if (
            item.title === "QA" ||
            item.title === "qa" ||
            item.title === "Qa" ||
            item.title === "qA"
          ) {
            return item.cards.length;
          }
        }),
        borderColor: "rgb(255, 205, 86)",
        backgroundColor: "rgba(255, 205, 86, 0.5)",
      },
    ],
  });

  const addMessage = () => {
    addNotification({
      title: "New Message",
      message: "you have only 5 minutes left",
      duration: new Date().getTime(),
      theme: "darkblue",
      position: "top-right",
      native: true,
      icon: pic1,
      onClick: () => {
        console.log("pushed");
      },
    });
  };

  const weekly = () => {
    setChartData({
      labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      datasets: [
        {
          fill: true,
          label: "Todo",
          data: dashBoard?.Boards?.map((item) => {
            if (
              item.title === "TODO" ||
              item.title === "todo" ||
              item.title === "ToDO" ||
              item.title === "ToDO" ||
              item.title === "TOdo" ||
              item.title === "TOdo" ||
              item.title === "tODO" ||
              item.title === "tODO" ||
              item.title === "toDO"
            ) {
              return item.cards.length;
            }
          }),

          borderColor: "rgb(53, 162, 235)",
          backgroundColor: "rgba(53, 162, 235, 0.5)",
        },
        {
          fill: true,
          label: "Progress",
          data: dashBoard?.Boards?.map((item) => {
            if (item.title === "PROGRESS" || item.title === "progress") {
              return item.cards.length;
            }
          }),
          borderColor: "rgb(255, 99, 132)",
          backgroundColor: "rgba(255, 99, 132, 0.5)",
        },
        {
          fill: true,
          label: "Done",
          data: dashBoard?.Boards?.map((item) => {
            if (
              item.title === "DONE" ||
              item.title === "done" ||
              item.title === "Done" ||
              item.title === "DoNE" ||
              item.title === "DONe" ||
              item.title === "dONE" ||
              item.title === "dOne" ||
              item.title === "doNE" ||
              item.title === "donE"
            ) {
              return item.cards.length;
            }
          }),
          borderColor: "rgb(75, 192, 192)",
          backgroundColor: "rgba(75, 192, 192, 0.5)",
        },
        {
          fill: true,
          label: "QA",
          data: dashBoard?.Boards?.map((item) => {
            if (
              item.title === "QA" ||
              item.title === "qa" ||
              item.title === "Qa" ||
              item.title === "qA"
            ) {
              return item.cards.length;
            }
          }),
          borderColor: "rgb(255, 205, 86)",
          backgroundColor: "rgba(255, 205, 86, 0.5)",
        },
      ],
    });
  };
  const monthly = () => {
    setChartData({
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      datasets: [
        {
          fill: true,
          label: "Todo",
          data: dashBoard?.Boards?.map((item) => {
            if (
              item.title === "TODO" ||
              item.title === "todo" ||
              item.title === "ToDO" ||
              item.title === "ToDO" ||
              item.title === "TOdo" ||
              item.title === "TOdo" ||
              item.title === "tODO" ||
              item.title === "tODO" ||
              item.title === "toDO"
            ) {
              return item.cards.length;
            }
          }),

          borderColor: "rgb(53, 162, 235)",
          backgroundColor: "rgba(53, 162, 235, 0.5)",
        },
        {
          fill: true,
          label: "Progress",
          data: dashBoard?.Boards?.map((item) => {
            if (item.title === "PROGRESS" || item.title === "progress") {
              return item.cards.length;
            }
          }),
          borderColor: "rgb(255, 99, 132)",
          backgroundColor: "rgba(255, 99, 132, 0.5)",
        },
        {
          fill: true,
          label: "Done",
          data: dashBoard?.Boards?.map((item) => {
            if (
              item.title === "DONE" ||
              item.title === "done" ||
              item.title === "Done" ||
              item.title === "DoNE" ||
              item.title === "DONe" ||
              item.title === "dONE" ||
              item.title === "dOne" ||
              item.title === "doNE" ||
              item.title === "donE"
            ) {
              return item.cards.length;
            }
          }),
          borderColor: "rgb(75, 192, 192)",
          backgroundColor: "rgba(75, 192, 192, 0.5)",
        },
        {
          fill: true,
          label: "QA",
          data: dashBoard?.Boards?.map((item) => {
            if (
              item.title === "QA" ||
              item.title === "qa" ||
              item.title === "Qa" ||
              item.title === "qA"
            ) {
              return item.cards.length;
            }
          }),
          borderColor: "rgb(255, 205, 86)",
          backgroundColor: "rgba(255, 205, 86, 0.5)",
        },
      ],
    });
  };
  let { id } = useParams();
  const getDashBoardData = async () => {
    const data = await getTaskById(id)
      .then((res) => {
        let members = res.boards.member.length;
        setMembersLength(members);
        setDashBoard(res.boards);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  useEffect(() => {
    getDashBoardData();
  }, []);

  const totalPoints = dashBoard?.Boards?.map((Boarditem) => {
    return Boarditem.cards.filter((cardItem) => {
      return cardItem.points;
    });
  });
  let final = [];
  totalPoints?.map((elm, index) => {
    elm.map((elm2) => {
      if (elm2.points) {
        final.push(elm2.points);
      }
    });
  });
  let sum = final.reduce(
    (accumulate, currentValue) => accumulate + currentValue,
    0
  );

  return (
    <>
      <div className="px-5">
        <h1 className="mt-4 text-light">Dashboard</h1>
        <ol className="breadcrumb mb-4">
          <li className="breadcrumb-item active text-light">
            {dashBoard.title}
          </li>
        </ol>
        <div className="row">
          <div className="col-xl-3 col-md-6">
            <div className="card bg-success text-white mb-4">
              <div className="card-body">Completed Task</div>
              {dashBoard?.Boards?.map((item, index) => {
                if (
                  item.title === "DONE" ||
                  item.title === "done" ||
                  item.title === "Done" ||
                  item.title === "DoNE" ||
                  item.title === "DONe" ||
                  item.title === "dONE" ||
                  item.title === "dOne" ||
                  item.title === "doNE" ||
                  item.title === "donE" ||
                  item.title === "COMPLETED" ||
                  item.title === "completed"
                ) {
                  let totlal = [];
                  item.cards.map((cardItem) => {
                    if (cardItem.points) {
                      totlal.push(cardItem.points);
                    }
                  });
                  let sum2 = totlal.reduce(
                    (accumulate, currentValue) => accumulate + currentValue,
                    0
                  );

                  return (
                    <div key={index}>
                      <h1 className="p54"> {item.cards.length}</h1>
                      <p className="storyPoints d-flex justify-content-end px-2">{`Story Points: ${sum2}`}</p>
                    </div>
                  );
                }
              })}
              <div className="card-footer d-flex align-items-center justify-content-between pr-3">
                {/* <a className="small text-white stretched-link" href="#">View Details</a> */}
                <Link
                  to="../TrackTasks"
                  className="small text-white stretched-link"
                >
                  View Details
                </Link>
                <div className="small text-white">
                  <i className="fas fa-angle-right" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6">
            <div className="card bg-warning text-white mb-4">
              <div className="card-body">Members</div>

              {<h1 className="p54">{membersLength ? membersLength : 0}</h1>}
              <div className="card-footer d-flex align-items-center justify-content-between">
                <Link
                  to="../members"
                  className="small text-white stretched-link"
                >
                  View Details
                </Link>
                <div className="small text-white">
                  <i className="fas fa-angle-right" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6">
            <div className="card bg-primary text-white mb-4">
              <div className="card-body">In Progress</div>
              {dashBoard?.Boards?.map((item, index) => {
                if (
                  item.title === "PROGRESS" ||
                  item.title === "progress" ||
                  item.title === "Progress"
                ) {
                  return (
                    <h1 className="p54" key={index}>
                      {item.cards.length}{" "}
                    </h1>
                  );
                }
              })}
              <div className="card-footer d-flex align-items-center justify-content-between">
                <a className="small text-white stretched-link" href="#">
                  View Details
                </a>
                <div className="small text-white">
                  <i className="fas fa-angle-right" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6">
            <div className="card bg-danger text-white mb-4">
              <div className="card-body">Pending</div>
              <h1 className="p54">10</h1>
              <div className="card-footer d-flex align-items-center justify-content-between">
                <a className="small text-white stretched-link" href="#">
                  View Details
                </a>
                <div className="small text-white">
                  <i className="fas fa-angle-right" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <div className="p-2">
            <button className="btn btn-primary" onClick={weekly}>
              Weekly
            </button>
            &nbsp;
            <button className="btn btn-info text-light" onClick={monthly}>
              Month
            </button>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-6">
            <div className="card mb-4">
              <div className="card-header">
                <i className="fas fa-chart-area mr-1"></i>
                Area Chart Example
              </div>
              <div className="card-body">
                <Line data={chartData} />
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="card mb-4">
              <div className="card-header">
                <i className="fas fa-chart-bar mr-1"></i>
                Bar Chart Example
              </div>
              <div className="card-body">
                <Bar data={chartData} />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header">
                <i className="fas fa-table mr-1"></i>
                Task Table
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    className="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellSpacing={0}
                  >
                    <thead>
                      <tr>
                        <th>Task</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {
                        dashBoard[0]?.Boards?.map((item) => {
                          return (
                            item.cards.map((card) => {
                              return (
                                <tr>
                                  <td>{card.title}</td>
                                  <td>{card.start}</td>
                                  <td>{card.end}</td>
                                  <td>{card.status}</td>
                                </tr>
                              )
                            })
                          )
                        }
                        )
                      } */}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
